import consumer from "./consumer";
import 'bootstrap/js/dist/toast';

class OnlineUsersChannel {
  static init() {
    if (['student', 'professor'].includes(Traus.company.user.role))
      return;

    this.cable = consumer.subscriptions.create({ channel: 'UserOnlineChannel', sub_domain: Traus.company.sub_domain }, {
        received: (data) => {
          if (!data.user)
            return;

          let element = document.querySelector('#online-users');

          if (!!element && data.action == 'destroy') {
            let userRow = element.querySelector(`#user_${data.user.id}`);
            !!userRow && userRow.remove();
            return;
          }

          if (data.action == 'create') {
            document.querySelector('.body').insertAdjacentHTML('beforebegin', `
              <div class="position-fixed bg-white top-0 right-0 p-3 rounded border" style="z-index: 1100; right: 10px; top: 10px; width: 300px;" id="user-online-toast">
                <div id="liveToast" class="toast hide" role="alert" aria-live="assertive" aria-atomic="true" data-delay="6000">
                  <div class="toast-header">
                    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="toast-body">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
                    </svg>
                    <span class="text-capitalize font-weight-500">
                      ${data.user.name.toLowerCase()}
                    </span> acabou de entrar.
                    <div class="text-muted">${data.user.email}</div>
                  </div>
                </div>
              </div>
            `);
            $('#liveToast').toast('show').on('hidden.bs.toast', function() {
              this.closest('#user-online-toast').remove();
            });

            if (!element)
              return;

            let userPath = element.dataset.userPath;
            element.insertAdjacentHTML('beforeend', `
              <li class="list-group-item d-flex align-items-center justify-content-between" id="user_${data.user.id}">
                <div class="col-lg-11 col-md-10 col-sm-10 col-10">
                  <div class="d-flex align-items-start">
                    <span class="user-avatar"><i class="fas fa-user-circle font-grey font-xl"></i></span>
                    <span class="d-block text-truncate">
                      <a href="${userPath.replaceAll('replace_id', data.user.id)}" class="text-truncate font-capitalize ml-2">${data.user.name.toLowerCase()}</a>
                    </span>
                  </div>
                  <span class="d-block text-sm">
                    <span class="text-muted"><i class="fas fa-envelop text-muted text-xs"></i> ${data.user.email}</span>
                  </span>
                </div>
              </li>
            `);
          }
        }
      }
    );
  }
}

$(() => OnlineUsersChannel.init());